import './scss/index.scss';

import { State } from './lib';
import { 
  Carousel, 
  CarouselInfo, 
  CarouselNext, 
  CarouselPrev,
  CarouselThumb,
} from './component';

import { ICarouselState } from './view-model/CarouselState';
import CarouselThumbNext from './component/carousel-thumb-next';
import CarouselThumbPrev from './component/carousel-thumb-prev';

const initialState: ICarouselState = {
  index: 0,
  // pageIndex: 0,
  limit: 5,
  list: [
    {
      "id":"c1",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170919_172/auto_1505802094784hvqgh_JPEG/20170919152131_p5j9fjk4.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170919_172/auto_1505802094784hvqgh_JPEG/20170919152131_p5j9fjk4.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170919_172/auto_1505802094784hvqgh_JPEG/20170919152131_p5j9fjk4.jpg",
    },
    {
      "id":"c2",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170919_269/auto_1505802095483flgVz_JPEG/20170919152132_3JE8Z1Ps.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170919_269/auto_1505802095483flgVz_JPEG/20170919152132_3JE8Z1Ps.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170919_269/auto_1505802095483flgVz_JPEG/20170919152132_3JE8Z1Ps.jpg",
    },
    {
      "id":"c3",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170919_101/auto_1505802095956cTY9h_JPEG/20170919152132_Qw8haQsG.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170919_101/auto_1505802095956cTY9h_JPEG/20170919152132_Qw8haQsG.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170919_101/auto_1505802095956cTY9h_JPEG/20170919152132_Qw8haQsG.jpg",
    },
    {
      "id":"c4",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170919_289/auto_1505802096506nFQIu_JPEG/20170919152132_NoO9dE5K.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170919_289/auto_1505802096506nFQIu_JPEG/20170919152132_NoO9dE5K.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170919_289/auto_1505802096506nFQIu_JPEG/20170919152132_NoO9dE5K.jpg",
    },
    {
      "id":"c5",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170919_204/auto_15058020969000plST_JPEG/20170919152133_3jXoe6Ll.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170919_204/auto_15058020969000plST_JPEG/20170919152133_3jXoe6Ll.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170919_204/auto_15058020969000plST_JPEG/20170919152133_3jXoe6Ll.jpg",
    },
    {
      "id":"c6",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170919_279/auto_1505802097376rXraL_JPEG/20170919152133_LH9yrEQ4.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170919_279/auto_1505802097376rXraL_JPEG/20170919152133_LH9yrEQ4.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170919_279/auto_1505802097376rXraL_JPEG/20170919152133_LH9yrEQ4.jpg",
    },
    {
      "id":"c7",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_282/auto_15052824334931An1N_JPEG/20170913150028_2fv2mRE6.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_282/auto_15052824334931An1N_JPEG/20170913150028_2fv2mRE6.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_282/auto_15052824334931An1N_JPEG/20170913150028_2fv2mRE6.jpg",
    },
    {
      "id":"c8",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_66/auto_1505282431383pf420_JPEG/20170913150027_psY1Khf6.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_66/auto_1505282431383pf420_JPEG/20170913150027_psY1Khf6.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_66/auto_1505282431383pf420_JPEG/20170913150027_psY1Khf6.jpg",
    },
    {
      "id":"c9",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_269/auto_1505282430593ELuy6_JPEG/20170913150027_AEF8B7gO.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_269/auto_1505282430593ELuy6_JPEG/20170913150027_AEF8B7gO.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_269/auto_1505282430593ELuy6_JPEG/20170913150027_AEF8B7gO.jpg",
    },
    {
      "id":"c10",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_282/auto_15052824330158oDWC_JPEG/20170913150028_MydT9oSZ.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_282/auto_15052824330158oDWC_JPEG/20170913150028_MydT9oSZ.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_282/auto_15052824330158oDWC_JPEG/20170913150028_MydT9oSZ.jpg",
    },
    {
      "id":"c11",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_99/auto_1505282435726pu6BT_JPEG/20170913150029_gO2NXtFL.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_99/auto_1505282435726pu6BT_JPEG/20170913150029_gO2NXtFL.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_99/auto_1505282435726pu6BT_JPEG/20170913150029_gO2NXtFL.jpg",
    },
    {
      "id":"c12",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_173/auto_1505282034289uzRu0_JPEG/20170913145350_Mw9m158V.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_173/auto_1505282034289uzRu0_JPEG/20170913145350_Mw9m158V.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_173/auto_1505282034289uzRu0_JPEG/20170913145350_Mw9m158V.jpg",
    },
    {
      "id":"c13",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_33/auto_15052824339172toex_JPEG/20170913150028_7k3Aj0hZ.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_33/auto_15052824339172toex_JPEG/20170913150028_7k3Aj0hZ.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_33/auto_15052824339172toex_JPEG/20170913150028_7k3Aj0hZ.jpg",
    },
    {
      "id":"c14",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_164/auto_1505282434469huRxi_JPEG/20170913150028_imehlKet.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_164/auto_1505282434469huRxi_JPEG/20170913150028_imehlKet.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_164/auto_1505282434469huRxi_JPEG/20170913150028_imehlKet.jpg",
    },
    {
      "id":"c15",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_169/auto_1505282434918MclBs_JPEG/20170913150029_SqDcY36e.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_169/auto_1505282434918MclBs_JPEG/20170913150029_SqDcY36e.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_169/auto_1505282434918MclBs_JPEG/20170913150029_SqDcY36e.jpg",
    },
    {
      "id":"c16",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_283/auto_1505282034751PppVn_JPEG/20170913145351_Hjmih9aW.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_283/auto_1505282034751PppVn_JPEG/20170913145351_Hjmih9aW.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_283/auto_1505282034751PppVn_JPEG/20170913145351_Hjmih9aW.jpg",
    },
    {
      "id":"c17",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_40/auto_15052820361775WXtK_JPEG/20170913145351_9qtDcYkH.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_40/auto_15052820361775WXtK_JPEG/20170913145351_9qtDcYkH.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_40/auto_15052820361775WXtK_JPEG/20170913145351_9qtDcYkH.jpg",
    },
    {
      "id":"c18",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_186/auto_1505282077570ypEBw_JPEG/20170913145434_Dxgds6IH.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_186/auto_1505282077570ypEBw_JPEG/20170913145434_Dxgds6IH.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_186/auto_1505282077570ypEBw_JPEG/20170913145434_Dxgds6IH.jpg",
    },
    {
      "id":"c19",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_46/auto_1505282078899ltRou_JPEG/20170913145434_JFzJb9OJ.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_46/auto_1505282078899ltRou_JPEG/20170913145434_JFzJb9OJ.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_46/auto_1505282078899ltRou_JPEG/20170913145434_JFzJb9OJ.jpg",
    },
    {
      "id":"c20",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_230/auto_1505282079381IQcrs_JPEG/20170913145435_VyWwSFdS.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_230/auto_1505282079381IQcrs_JPEG/20170913145435_VyWwSFdS.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_230/auto_1505282079381IQcrs_JPEG/20170913145435_VyWwSFdS.jpg",
    },
    {
      "id":"c21",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_144/auto_150528207984514YYB_JPEG/20170913145435_asuGBwe7.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_144/auto_150528207984514YYB_JPEG/20170913145435_asuGBwe7.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_144/auto_150528207984514YYB_JPEG/20170913145435_asuGBwe7.jpg",
    },
    {
      "id":"c22",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_286/auto_1505282080335mdipX_JPEG/20170913145435_n56QdtCT.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_286/auto_1505282080335mdipX_JPEG/20170913145435_n56QdtCT.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_286/auto_1505282080335mdipX_JPEG/20170913145435_n56QdtCT.jpg",
    },
    {
      "id":"c23",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_88/auto_1505282080709mBktz_JPEG/20170913145435_HMoUTqCG.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_88/auto_1505282080709mBktz_JPEG/20170913145435_HMoUTqCG.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_88/auto_1505282080709mBktz_JPEG/20170913145435_HMoUTqCG.jpg",
    },
    {
      "id":"c24",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_262/auto_1505282081057shrSq_JPEG/20170913145435_kXTUjdEs.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_262/auto_1505282081057shrSq_JPEG/20170913145435_kXTUjdEs.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_262/auto_1505282081057shrSq_JPEG/20170913145435_kXTUjdEs.jpg",
    },
    {
      "id":"c25",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_211/auto_1505282081591GEyeF_JPEG/20170913145436_Z4kEkK0M.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_211/auto_1505282081591GEyeF_JPEG/20170913145436_Z4kEkK0M.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_211/auto_1505282081591GEyeF_JPEG/20170913145436_Z4kEkK0M.jpg",
    },
    {
      "id":"c26",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_123/auto_1505282082025wuH5W_JPEG/20170913145436_23wGtgGx.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_123/auto_1505282082025wuH5W_JPEG/20170913145436_23wGtgGx.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_123/auto_1505282082025wuH5W_JPEG/20170913145436_23wGtgGx.jpg",
    },
    {
      "id":"c27",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_232/auto_1505282082463KqOoA_JPEG/20170913145436_mcufh6xE.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_232/auto_1505282082463KqOoA_JPEG/20170913145436_mcufh6xE.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_232/auto_1505282082463KqOoA_JPEG/20170913145436_mcufh6xE.jpg",
    },
    {
      "id":"c28",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_44/auto_1505282082910zgK4W_JPEG/20170913145436_YMx4d54b.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_44/auto_1505282082910zgK4W_JPEG/20170913145436_YMx4d54b.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_44/auto_1505282082910zgK4W_JPEG/20170913145436_YMx4d54b.jpg",
    },
    {
      "id":"c29",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_204/auto_1505282083390B3NMP_JPEG/20170913145436_B7RI1REx.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_204/auto_1505282083390B3NMP_JPEG/20170913145436_B7RI1REx.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_204/auto_1505282083390B3NMP_JPEG/20170913145436_B7RI1REx.jpg",
    },
    {
      "id":"c30",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_117/auto_1505282083823Duz6F_JPEG/20170913145436_RM873t2E.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_117/auto_1505282083823Duz6F_JPEG/20170913145436_RM873t2E.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_117/auto_1505282083823Duz6F_JPEG/20170913145436_RM873t2E.jpg",
    },
    {
      "id":"c31",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_10/auto_1505282084525FHBNS_JPEG/20170913145436_mVMKqLTW.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_10/auto_1505282084525FHBNS_JPEG/20170913145436_mVMKqLTW.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_10/auto_1505282084525FHBNS_JPEG/20170913145436_mVMKqLTW.jpg",
    },
    {
      "id":"c32",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_120/auto_1505282090957CVlnt_JPEG/20170913145449_ZRyuub77.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_120/auto_1505282090957CVlnt_JPEG/20170913145449_ZRyuub77.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_120/auto_1505282090957CVlnt_JPEG/20170913145449_ZRyuub77.jpg",
    },
    {
      "id":"c33",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_99/auto_1505282091443S7rP0_JPEG/20170913145450_CFFJiGok.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_99/auto_1505282091443S7rP0_JPEG/20170913145450_CFFJiGok.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_99/auto_1505282091443S7rP0_JPEG/20170913145450_CFFJiGok.jpg",
    },
    {
      "id":"c34",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_141/auto_1505282091792EiqKS_JPEG/20170913145450_DseRIGVf.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_141/auto_1505282091792EiqKS_JPEG/20170913145450_DseRIGVf.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_141/auto_1505282091792EiqKS_JPEG/20170913145450_DseRIGVf.jpg",
    },
    {
      "id":"c35",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_249/auto_1505455991548uS8RS_JPEG/20170915151309_yM0Jy6Eb.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_249/auto_1505455991548uS8RS_JPEG/20170915151309_yM0Jy6Eb.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_249/auto_1505455991548uS8RS_JPEG/20170915151309_yM0Jy6Eb.jpg",
    },
    {
      "id":"c36",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_73/auto_15052820921515rFsc_JPEG/20170913145450_5rs074bG.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_73/auto_15052820921515rFsc_JPEG/20170913145450_5rs074bG.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_73/auto_15052820921515rFsc_JPEG/20170913145450_5rs074bG.jpg",
    },
    {
      "id":"c37",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_104/auto_1505282174963n3Mrd_JPEG/20170913145559_rpCxSdED.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_104/auto_1505282174963n3Mrd_JPEG/20170913145559_rpCxSdED.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_104/auto_1505282174963n3Mrd_JPEG/20170913145559_rpCxSdED.jpg",
    },
    {
      "id":"c38",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_106/auto_15052821754487Jitk_JPEG/20170913145559_bjEJYffR.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_106/auto_15052821754487Jitk_JPEG/20170913145559_bjEJYffR.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_106/auto_15052821754487Jitk_JPEG/20170913145559_bjEJYffR.jpg",
    },
    {
      "id":"c39",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_66/auto_1505282175903Y9D5l_JPEG/20170913145600_LYANhIit.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_66/auto_1505282175903Y9D5l_JPEG/20170913145600_LYANhIit.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_66/auto_1505282175903Y9D5l_JPEG/20170913145600_LYANhIit.jpg",
    },
    {
      "id":"c40",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_281/auto_1505282176329YEicW_JPEG/20170913145600_jPsSoq6t.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_281/auto_1505282176329YEicW_JPEG/20170913145600_jPsSoq6t.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_281/auto_1505282176329YEicW_JPEG/20170913145600_jPsSoq6t.jpg",
    },
    {
      "id":"c41",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_46/auto_1505282176748hAJ7t_JPEG/20170913145600_YIxMjgvx.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_46/auto_1505282176748hAJ7t_JPEG/20170913145600_YIxMjgvx.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_46/auto_1505282176748hAJ7t_JPEG/20170913145600_YIxMjgvx.jpg",
    },
    {
      "id":"c42",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_298/auto_1505282177129FXBtB_JPEG/20170913145600_hZXXHleV.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_298/auto_1505282177129FXBtB_JPEG/20170913145600_hZXXHleV.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_298/auto_1505282177129FXBtB_JPEG/20170913145600_hZXXHleV.jpg",
    },
    {
      "id":"c43",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_184/auto_15052821775695cpJk_JPEG/20170913145600_n978ERpJ.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_184/auto_15052821775695cpJk_JPEG/20170913145600_n978ERpJ.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_184/auto_15052821775695cpJk_JPEG/20170913145600_n978ERpJ.jpg",
    },
    {
      "id":"c44",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_243/auto_1505282178021QmMt7_JPEG/20170913145600_Rtw9oA7k.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_243/auto_1505282178021QmMt7_JPEG/20170913145600_Rtw9oA7k.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_243/auto_1505282178021QmMt7_JPEG/20170913145600_Rtw9oA7k.jpg",
    },
    {
      "id":"c45",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_192/auto_1505282178501v9F4s_JPEG/20170913145601_Ux5iTbFH.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_192/auto_1505282178501v9F4s_JPEG/20170913145601_Ux5iTbFH.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_192/auto_1505282178501v9F4s_JPEG/20170913145601_Ux5iTbFH.jpg",
    },
    {
      "id":"c46",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_273/auto_1505282179991NKEMT_JPEG/20170913145604_A3EBW5GO.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_273/auto_1505282179991NKEMT_JPEG/20170913145604_A3EBW5GO.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_273/auto_1505282179991NKEMT_JPEG/20170913145604_A3EBW5GO.jpg",
    },
    {
      "id":"c47",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_19/auto_1505282180437J9Iy8_JPEG/20170913145604_orzt40wv.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_19/auto_1505282180437J9Iy8_JPEG/20170913145604_orzt40wv.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_19/auto_1505282180437J9Iy8_JPEG/20170913145604_orzt40wv.jpg",
    },
    {
      "id":"c48",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_27/auto_1505282181163gB0Hx_JPEG/20170913145604_g0ABXstF.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_27/auto_1505282181163gB0Hx_JPEG/20170913145604_g0ABXstF.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_27/auto_1505282181163gB0Hx_JPEG/20170913145604_g0ABXstF.jpg",
    },
    {
      "id":"c49",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_130/auto_1505282181556Hb0Sc_JPEG/20170913145609_wrPgACGX.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_130/auto_1505282181556Hb0Sc_JPEG/20170913145609_wrPgACGX.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_130/auto_1505282181556Hb0Sc_JPEG/20170913145609_wrPgACGX.jpg",
    },
    {
      "id":"c50",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_174/auto_1505282181990Ddc55_JPEG/20170913145610_Mk3s17jG.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_174/auto_1505282181990Ddc55_JPEG/20170913145610_Mk3s17jG.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_174/auto_1505282181990Ddc55_JPEG/20170913145610_Mk3s17jG.jpg",
    },
    {
      "id":"c51",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_220/auto_15052821823523U6ap_JPEG/20170913145610_0AvCEvZV.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_220/auto_15052821823523U6ap_JPEG/20170913145610_0AvCEvZV.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_220/auto_15052821823523U6ap_JPEG/20170913145610_0AvCEvZV.jpg",
    },
    {
      "id":"c52",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_239/auto_1505282182735uwanh_JPEG/20170913145610_UNp0cxob.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_239/auto_1505282182735uwanh_JPEG/20170913145610_UNp0cxob.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_239/auto_1505282182735uwanh_JPEG/20170913145610_UNp0cxob.jpg",
    },
    {
      "id":"c53",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_155/auto_1505282183141IjvIJ_JPEG/20170913145610_WHwqf1Yz.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_155/auto_1505282183141IjvIJ_JPEG/20170913145610_WHwqf1Yz.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_155/auto_1505282183141IjvIJ_JPEG/20170913145610_WHwqf1Yz.jpg",
    },
    {
      "id":"c54",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_102/auto_15052821836129kgAF_JPEG/20170913145610_Sm1lbBSl.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_102/auto_15052821836129kgAF_JPEG/20170913145610_Sm1lbBSl.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_102/auto_15052821836129kgAF_JPEG/20170913145610_Sm1lbBSl.jpg",
    },
    {
      "id":"c55",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_24/auto_1505282184071T9Yat_JPEG/20170913145611_fj2CCL2i.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_24/auto_1505282184071T9Yat_JPEG/20170913145611_fj2CCL2i.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_24/auto_1505282184071T9Yat_JPEG/20170913145611_fj2CCL2i.jpg",
    },
    {
      "id":"c56",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_131/auto_150528218468893CsM_JPEG/20170913145611_Ur5jZumk.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_131/auto_150528218468893CsM_JPEG/20170913145611_Ur5jZumk.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_131/auto_150528218468893CsM_JPEG/20170913145611_Ur5jZumk.jpg",
    },
    {
      "id":"c57",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_111/auto_1505282185141rnE8D_JPEG/20170913145611_kkYZq90y.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_111/auto_1505282185141rnE8D_JPEG/20170913145611_kkYZq90y.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_111/auto_1505282185141rnE8D_JPEG/20170913145611_kkYZq90y.jpg",
    },
    {
      "id":"c58",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_213/auto_150528243174920fJu_JPEG/20170913150027_n4Fzp21E.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_213/auto_150528243174920fJu_JPEG/20170913150027_n4Fzp21E.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_213/auto_150528243174920fJu_JPEG/20170913150027_n4Fzp21E.jpg",
    },
    {
      "id":"c59",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_107/auto_1505282432234DiTnI_JPEG/20170913150027_ukUMnQzH.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_107/auto_1505282432234DiTnI_JPEG/20170913150027_ukUMnQzH.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_107/auto_1505282432234DiTnI_JPEG/20170913150027_ukUMnQzH.jpg",
    },
    {
      "id":"c60",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_87/auto_1505282432691lgyCU_JPEG/20170913150028_syBqbW1d.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_87/auto_1505282432691lgyCU_JPEG/20170913150028_syBqbW1d.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_87/auto_1505282432691lgyCU_JPEG/20170913150028_syBqbW1d.jpg",
    },
    {
      "id":"c61",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170913_278/auto_1505282035220HOz6J_JPEG/20170913145351_b7W3MBAd.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170913_278/auto_1505282035220HOz6J_JPEG/20170913145351_b7W3MBAd.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170913_278/auto_1505282035220HOz6J_JPEG/20170913145351_b7W3MBAd.jpg",
    },
    {
      "id":"c62",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_123/auto_1505448242723JRW9e_JPEG/20170915130359_zRUNflHL.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_123/auto_1505448242723JRW9e_JPEG/20170915130359_zRUNflHL.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_123/auto_1505448242723JRW9e_JPEG/20170915130359_zRUNflHL.jpg",
    },
    {
      "id":"c63",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_138/auto_150544824308172WUj_JPEG/20170915130359_N3cUPdlz.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_138/auto_150544824308172WUj_JPEG/20170915130359_N3cUPdlz.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_138/auto_150544824308172WUj_JPEG/20170915130359_N3cUPdlz.jpg",
    },
    {
      "id":"c64",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_81/auto_1505448243702uXqB3_JPEG/20170915130359_Wz7gmFh9.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_81/auto_1505448243702uXqB3_JPEG/20170915130359_Wz7gmFh9.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_81/auto_1505448243702uXqB3_JPEG/20170915130359_Wz7gmFh9.jpg",
    },
    {
      "id":"c65",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_240/auto_1505448244099afiR3_JPEG/20170915130400_hV7SMPhN.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_240/auto_1505448244099afiR3_JPEG/20170915130400_hV7SMPhN.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_240/auto_1505448244099afiR3_JPEG/20170915130400_hV7SMPhN.jpg",
    },
    {
      "id":"c66",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_63/auto_15054482444153PLas_JPEG/20170915130400_bolzRNci.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_63/auto_15054482444153PLas_JPEG/20170915130400_bolzRNci.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_63/auto_15054482444153PLas_JPEG/20170915130400_bolzRNci.jpg",
    },
    {
      "id":"c67",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_189/auto_1505448245034LfgwA_JPEG/20170915130400_3pqqoio1.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_189/auto_1505448245034LfgwA_JPEG/20170915130400_3pqqoio1.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_189/auto_1505448245034LfgwA_JPEG/20170915130400_3pqqoio1.jpg",
    },
    {
      "id":"c68",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_208/auto_1505448245478by4Mj_JPEG/20170915130401_kH1qsKy3.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_208/auto_1505448245478by4Mj_JPEG/20170915130401_kH1qsKy3.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_208/auto_1505448245478by4Mj_JPEG/20170915130401_kH1qsKy3.jpg",
    },
    {
      "id":"c69",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_5/auto_15054482458319QbnD_JPEG/20170915130401_iZ0K6EBB.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_5/auto_15054482458319QbnD_JPEG/20170915130401_iZ0K6EBB.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_5/auto_15054482458319QbnD_JPEG/20170915130401_iZ0K6EBB.jpg",
    },
    {
      "id":"c70",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_161/auto_1505448246177T1i5Q_JPEG/20170915130401_FleDvGQ9.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_161/auto_1505448246177T1i5Q_JPEG/20170915130401_FleDvGQ9.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_161/auto_1505448246177T1i5Q_JPEG/20170915130401_FleDvGQ9.jpg",
    },
    {
      "id":"c71",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_66/auto_1505448255974qtDdv_JPEG/20170915130412_NyIYinxa.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_66/auto_1505448255974qtDdv_JPEG/20170915130412_NyIYinxa.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_66/auto_1505448255974qtDdv_JPEG/20170915130412_NyIYinxa.jpg",
    },
    {
      "id":"c72",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_44/auto_1505448256393umpvY_JPEG/20170915130412_Py8QR6sU.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_44/auto_1505448256393umpvY_JPEG/20170915130412_Py8QR6sU.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_44/auto_1505448256393umpvY_JPEG/20170915130412_Py8QR6sU.jpg",
    },
    {
      "id":"c73",
      "thumbURL":"https://imgauto-phinf.pstatic.net/20170915_45/auto_1505448256949tNjE5_JPEG/20170915130412_VvCnHn9Q.jpg?type=f120_80",
      "viewURL":"https://imgauto-phinf.pstatic.net/20170915_45/auto_1505448256949tNjE5_JPEG/20170915130412_VvCnHn9Q.jpg?type=f980_654",
      "originURL":"https://imgauto-phinf.pstatic.net/20170915_45/auto_1505448256949tNjE5_JPEG/20170915130412_VvCnHn9Q.jpg",
    }
  ]
};

(async function() {
  'use strict';
  const store: any = new State(initialState);

  const carouselInfo = new CarouselInfo(store, "#carousel-info");
  const carousel = new Carousel(store, "#carousel");
  const carouselNext = new CarouselNext(store, "#carousel-buttons-next");
  const carousePrev = new CarouselPrev(store, "#carousel-buttons-prev");
  const carouselThumb = new CarouselThumb(store, "#carousel-thumb");
  const carouselThumbNext = new CarouselThumbNext(store, "#carousel-thumb-buttons-next");
  const carouselThumbPrev = new CarouselThumbPrev(store, "#carousel-thumb-buttons-prev");


  store.addObservers([
    carouselInfo,
    carousel,
    carouselNext,
    carousePrev,
    carouselThumb,
    carouselThumbNext,
    carouselThumbPrev,
  ])

  carouselInfo.render();
  carousel.render();
  carouselNext.render();
  carousePrev.render();
  carouselThumb.render();
  carouselThumbNext.render();
  carouselThumbPrev.render();
})();
